export default [
  {
    type: 'ecommerce',
    identifiers: ['moovin', 'oneeg', 'ecomece']
  },
  {
    type: 'erp',
    identifiers: ['tiny', 'flexy']
  },
  {
    type: 'tool',
    identifiers: ['api']
  }
]



// WEBPACK FOOTER //
// ./src/storage/expediter.js